import * as ol from 'openlayers'
import { DataTheme } from 'src/Enums'
import legendImage from '../../img/legend_ice_age.png'
import { ContextTag } from '../wiki/Wiki'
import { AbstractLayer, AbstractLayerOptions, GeoLayer, SubLayerDescriptor } from './Layer'
import { layerCopyrights, LayerDescription, LayerGroup, LayerParamsObject, LayerType } from './LayerRegistry'

/**
 * Map layer class for the ice age WMS sources from Geo.
 */
class IceAgeLayer extends AbstractLayer implements GeoLayer {
  private static readonly descriptors: SubLayerDescriptor[] = [
    {
      value: 0,
      label: 'I dag',
      subLayer: '',
      subLabel: 'map.layer.iceage.now'
    },
    {
      value: -12600,
      label: '12.600 - 11.700 f.v.t.',
      subLayer: 'istid-11-5-yd',
      subLabel: 'map.layer.iceage.yngredryas',
      wikiKey: 'yngredryas'
    },
    {
      value: -13900,
      label: '13.900 - 12.600 f.v.t.',
      subLayer: 'istid-13-alleroed',
      subLabel: 'map.layer.iceage.alleroed',
      wikiKey: 'alleroed'
    },
    {
      value: -14000,
      label: '14.050 - 13.900 f.v.t.',
      subLayer: 'istid-15-bholm',
      subLabel: 'map.layer.iceage.aeldredryas',
      wikiKey: 'aeldredryas'
    },
    {
      value: -14700,
      label: '14.700 - 14.050 f.v.t.',
      subLayer: 'istid-14-5-boelling',
      subLabel: 'map.layer.iceage.boelling',
      wikiKey: 'boelling'
    },
    {
      value: -17000,
      label: '17.000 - 14.700 f.v.t.',
      subLayer: 'istid-17-16-oeresund',
      subLabel: 'map.layer.iceage.aeldstedryas',
      wikiKey: 'aeldstedryas'
    },
    {
      value: -18000,
      label: '18.000 - 17.000 f.v.t.',
      subLayer: 'istid-18-baelthav',
      subLabel: 'map.layer.iceage.baelthavisstroem',
      wikiKey: 'baelthavisstroem'
    },
    {
      value: -19000,
      label: '19.000 - 18.000 f.v.t.',
      subLayer: 'istid-19-oestjysk',
      subLabel: 'map.layer.iceage.oestjyskisstroem',
      wikiKey: 'oestjyskisstroem'
    },
    {
      value: -20000,
      label: '20.000 - 19.000 f.v.t.',
      subLayer: 'istid-20-storebaelt',
      subLabel: 'map.layer.iceage.hovedfremstoedet',
      wikiKey: 'hovedfremstoedet'
    },
    {
      value: -23000,
      label: '23.000 - 20.000 f.v.t.',
      subLayer: 'istid-22-lgm',
      subLabel: 'map.layer.iceage.hovedopholdslinjen',
      wikiKey: 'hovedopholdslinjen'
    },
    {
      value: -26000,
      label: '26.000 - 23.000f.v.t.',
      subLayer: 'istid-25-glumsloev-moen',
      subLabel: 'map.layer.iceage.kattegatissoeninterfasen',
      wikiKey: 'kattegatissoeninterfasen'
    },
    {
      value: -28000,
      label: '28.000 - 26.000 f.v.t.',
      subLayer: 'istid-27-kattegatisstroem',
      subLabel: 'map.layer.iceage.kattegatisstroemmen',
      wikiKey: 'kattegatisstroemmen'
    },
    {
      value: -30000,
      label: '30.000 - 28.000 f.v.t.',
      subLayer: 'istid-28-kattegatissoe',
      subLabel: 'map.layer.iceage.kattegatissoeen',
      wikiKey: 'kattegatissoeen'
    },
    {
      value: -32000,
      label: '32.000 - 30.000 f.v.t.',
      subLayer: 'istid-30-sandnes',
      subLabel: 'map.layer.iceage.sandnesmildningen',
      wikiKey: 'moenkattegatinterstadial'
    },
    {
      value: -35000,
      label: '35.000 - 32.000 f.v.t.',
      subLayer: 'istid-35-klintholm',
      subLabel: 'map.layer.iceage.klinthomsfremstoedet',
      wikiKey: 'klinthomsfremstoedet'
    },
    {
      value: -45000,
      label: '45.000 - 35.000 f.v.t.',
      subLayer: 'istid-40-sejroe',
      subLabel: 'map.layer.iceage.sandnesmildningen',
      wikiKey: 'moenkattegatinterstadial'
    },
    {
      value: -50000,
      label: '50.000 - 45.000 f.v.t.',
      subLayer: 'istid-46-postristinge',
      subLabel: 'map.layer.iceage.vennebjergmildningen',
      wikiKey: 'sejeroeinterstadial'
    },
    {
      value: -55000,
      label: '55.000 - 50.000 f.v.t.',
      subLayer: 'istid-50-ristinge',
      subLabel: 'map.layer.iceage.ristingefremstoedet',
      wikiKey: 'ristingefremstoedet'
    },
    {
      value: -60000,
      label: '60.000 - 55.000 f.v.t.',
      subLayer: 'istid-60-hirtshals',
      subLabel: 'map.layer.iceage.hirtshalsmildningen',
      wikiKey: 'hirtshalsmildningen'
    },
    {
      value: -105000,
      label: '105.000 - 95.000 f.v.t.',
      subLayer: 'istid-100-broerup',
      subLabel: 'map.layer.iceage.boerupmildningen',
      wikiKey: 'boerupmildningen'
    },
    {
      value: -130000,
      label: '130.000 - 105.000 f.v.t.',
      subLayer: 'istid-125-eem',
      subLabel: 'map.layer.iceage.eemmellemistid',
      wikiKey: 'eemmellemistid'
    },
    {
      value: -135000,
      label: '135.000 - 130.000 f.v.t.',
      subLayer: 'istid-130-sen-saale',
      subLabel: 'map.layer.iceage.sensaaleistid',
      wikiKey: 'sensaaleistid'
    },
    {
      value: -145000,
      label: '145.000 - 140.000 f.v.t.',
      subLayer: 'istid-140-warthe',
      subLabel: 'map.layer.iceage.warthefremstoedet',
      wikiKey: 'warthefremstoedet'
    },
    {
      value: -180000,
      label: '180.000 - 160.000 f.v.t.',
      subLayer: 'istid-170-drenthe',
      subLabel: 'map.layer.iceage.drenthefremstoedet',
      wikiKey: 'drenthefremstoedet'
    }
  ]

  static readonly defaultParams: LayerParamsObject = {
    opacity: 0.5,
    subLayers: {
      labelId: 'map.layer.iceage.sublayers',
      key: 'istider',
      subLayerDescriptors: IceAgeLayer.descriptors,
      inputEnabled: true,
      stepperEnabled: true,
      maximum: 0,
      minimum: -170000,
      step: 0,
      unit: 'm',
      list: [],
      selected: IceAgeLayer.descriptors[0]
    }
  }

  constructor (options: any) {
    const defaultOptions: AbstractLayerOptions = {
      layerType: LayerType.ICE_AGE,
      enabled: true,
      minZoom: 6,
      zIndex: 3
    }
    super({ ...defaultOptions, ...options })

    let { subLayers, opacity } = options.params
    opacity = opacity === undefined ? IceAgeLayer.defaultParams.opacity : opacity

    const layer = subLayers !== undefined ? subLayers.selected.subLayer : ''

    this.olLayer = new ol.layer.Tile({
      visible: this.enabled,
      opacity: opacity,
      source: new ol.source.TileWMS({
        url: 'https://data.geo.dk/mapv2/geo-services/wms',
        params: {
          layers: layer,
          token: options.token
        }
      })
    })
  }

  static describe (): LayerDescription {
    return {
      type: LayerType.ICE_AGE,
      name: 'map.layer.iceage',
      group: LayerGroup.ICE_AGE,
      contextTags: [
        ContextTag.ICE_AGE
      ],
      themes: [DataTheme.ICE_AGE],
      capabilitiesUrl: '',
      legendEnabled: true,
      imageLegend: {
        legendImage: legendImage,
        imageHeight: 110,
        legendTextId: 'layerpicker.legend.text.iceage'
      },
      opacityEnabled: true,
      layerCopyright: layerCopyrights.Geo
    }
  }
}

export default IceAgeLayer
